import React from 'react';
import LayoutDashboard from 'app/private/layout';
import BlockIcon from '@material-ui/icons/Block';
import { Wrapper } from './index.styles';

const NoAccess: React.FC = () => (
    <LayoutDashboard>
        <Wrapper>
            <BlockIcon />
            <h2>You don't have an access to view this page</h2>
        </Wrapper>
    </LayoutDashboard>
);

export default NoAccess;
